'use client';

import { c as _c } from "react/compiler-runtime";
import { AuthenticationButton } from '@module/mdrt-org/shared/components/authentication-button/authentication-button';
import { useImpersonationModalContext } from '@module/mdrt-org/shared/components/header/components/impersonation-modal/impersonation-modal-context';
import { Admin, Gear, Impersonate } from '@shared/ui-components/svgs';
import { Link } from '../../../../i18n/i18n-navigation-link';
import { useUserContext } from '../../../providers/user-context';
import { type HeaderAccountDropdownContent } from '../../graphql/get-header-profile-dropdown-content';
import styles from './profile-dropdown-items.module.scss';
export const ProfileDropdownItems = t0 => {
  const $ = _c(30);
  const {
    cmsContent,
    isAuthenticated,
    onClose
  } = t0;
  const {
    hasCompanyAdminRole,
    hasStaffRole
  } = useUserContext();
  const {
    openImpersonationModal
  } = useImpersonationModalContext();
  let t1;
  if ($[0] !== cmsContent.accountLinkLabel || $[1] !== cmsContent.accountSettingsPagePath || $[2] !== onClose) {
    t1 = cmsContent.accountSettingsPagePath && <Link className={styles["profile-dropdown-item"]} href={cmsContent.accountSettingsPagePath} onClick={onClose}><Gear className={styles["profile-dropdown-item__icon"]} />{cmsContent.accountLinkLabel}</Link>;
    $[0] = cmsContent.accountLinkLabel;
    $[1] = cmsContent.accountSettingsPagePath;
    $[2] = onClose;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <li>{t1}</li>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== cmsContent.impersonationLinkLabel || $[7] !== hasStaffRole || $[8] !== onClose || $[9] !== openImpersonationModal) {
    t3 = hasStaffRole && <li><button className={styles["profile-dropdown-item-button"]} onClick={() => {
        onClose?.();
        openImpersonationModal();
      }} type="button"><Impersonate className={styles["profile-dropdown-item__icon"]} />{cmsContent.impersonationLinkLabel}</button></li>;
    $[6] = cmsContent.impersonationLinkLabel;
    $[7] = hasStaffRole;
    $[8] = onClose;
    $[9] = openImpersonationModal;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== cmsContent.companyAdminDashboardPageLinkLabel || $[12] !== cmsContent.companyAdminDashboardPagePath || $[13] !== hasCompanyAdminRole || $[14] !== hasStaffRole || $[15] !== onClose) {
    t4 = (hasCompanyAdminRole || hasStaffRole) && cmsContent.companyAdminDashboardPagePath && <li><Link className={styles["profile-dropdown-item"]} href={cmsContent.companyAdminDashboardPagePath} onClick={onClose}><Admin className={styles["profile-dropdown-item__icon"]} />{cmsContent.companyAdminDashboardPageLinkLabel}</Link></li>;
    $[11] = cmsContent.companyAdminDashboardPageLinkLabel;
    $[12] = cmsContent.companyAdminDashboardPagePath;
    $[13] = hasCompanyAdminRole;
    $[14] = hasStaffRole;
    $[15] = onClose;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== cmsContent.adminDashboardPageLinkLabel || $[18] !== cmsContent.adminDashboardPagePath || $[19] !== hasStaffRole || $[20] !== onClose) {
    t5 = hasStaffRole && cmsContent.adminDashboardPagePath && <li><Link className={styles["profile-dropdown-item"]} href={cmsContent.adminDashboardPagePath} onClick={onClose}><Admin className={styles["profile-dropdown-item__icon"]} />{cmsContent.adminDashboardPageLinkLabel}</Link></li>;
    $[17] = cmsContent.adminDashboardPageLinkLabel;
    $[18] = cmsContent.adminDashboardPagePath;
    $[19] = hasStaffRole;
    $[20] = onClose;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== isAuthenticated) {
    t6 = <li className={styles["profile-dropdown-item__with-divider"]}><AuthenticationButton isAuthenticated={isAuthenticated} /></li>;
    $[22] = isAuthenticated;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t7 = <>{t2}{t3}{t4}{t5}{t6}</>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
};